import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/scroll";
import CursorGlow from "@/components/CursorGlow";
import Nav from "@/components/Nav";
import Cover from "@/components/Cover";
import Acknowledgement from "@/components/Acknowledgement";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Crisis from "@/components/Crisis";
import RiverHistory from "@/components/RiverHistory";
import Product from "@/components/Product";
import Difference from "@/components/Difference";
import Audience from "@/components/Audience";
import Culture from "@/components/Culture";
import Repurpose from "@/components/Repurpose";
import Financials from "@/components/Financials";
import Roadmap from "@/components/Roadmap";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
    useEffect(() => {
        initLenis();
    }, []);

    return (
        <div className="App bg-[#020D18] text-slate-50">
            <div className="noise-overlay" aria-hidden="true" />
            <CursorGlow />
            <Nav />
            <main>
                <Cover />
                <Acknowledgement />
                <Hero />
                <Marquee />
                <Crisis />
                <RiverHistory />
                <Product />
                <Difference />
                <Audience />
                <Culture />
                <Repurpose />
                <Financials />
                <Roadmap />
                <Contact />
            </main>
            <Footer />
            <Toaster position="top-center" richColors />
        </div>
    );
}
